import React from 'react';

import _ from 'lodash';
import appStore from '@stores/app';
import { Tabs } from 'antd';

import GroupsView from 'Content/Groups/GroupsView';
import NewSessionsView from 'Content/Sessions/NewSessionsView';
import { commonConfig } from '@lib/contentConfig';
import { InitialSessionsView } from 'Screens/Content/Sessions/InitialSessions/InitialSessionsView';

const { TabPane } = Tabs;

const ContentConfigScreen = () => {
    return (
        <Tabs defaultActiveKey={'freeContent'} animated={false} type="card">
            {_.map(commonConfig, group => {
                const tab = (
                    <TabPane tab={group.name} key={group.groupType}>
                        <GroupsView {...group} />
                    </TabPane>
                );
                return group.advanced ? appStore.advancedMode && tab : tab;
            })}
            <TabPane tab="Initial Sessions" key="initialSessions">
                <InitialSessionsView />
            </TabPane>
        </Tabs>
    );
};

export { ContentConfigScreen };
